<template>
  <div class="comp-table-inner-edit-content" @click.stop="" :style="editFieldsObj?.isList ? { position: 'absolute', zIndex: 1001, top: getEditFieldObj.top, left: getEditFieldObj.left, width: getEditFieldObj.width, minWidth: '200px' } : editFieldsObj?.isDetail ? { position: 'absolute', zIndex: zIndex + 1, top: '-5px', left: '0', width: '100%' } : {}">
    <div class="ly-edit-fields-item">
      <!-- 单行文本/超链接-->
      <jw-input v-if="data.textList.includes(fieldType)" ref="focusRef" allow-clear v-model="getEditFieldObj.fieldValue" placeholder="请输入" @press-enter="editSave" />
      <!-- 多行文本域 -->
      <jw-textarea
        v-else-if="fieldType === 1"
        ref="focusRef"
        allow-clear
        v-model="getEditFieldObj.fieldValue"
        placeholder="请输入"
        :auto-size="{
          minRows: 2,
          maxRows: 5
        }"
      />
      <!-- 单选按钮/下拉单选 -->
      <jw-select :trigger-props="{ updateAtScroll: true }" v-else-if="data.redioList.includes(fieldType) && fieldExt" v-model="getEditFieldObj.fieldValue" placeholder="请选择" allow-clear allow-search @change="editSave" popup-visible>
        <jw-option v-for="item in JSON.parse(fieldExt)" :key="item.value" :value="item.value" :disabled="!item.isEnabled">{{ item.label }}</jw-option>
      </jw-select>
      <!-- 多选按钮/下拉多选 @popup-visible-change="popupVisibleChange"-->
      <template v-else-if="data.selectList.includes(fieldType) && fieldExt">
        <jw-select popup-visible :trigger-props="{ updateAtScroll: true }" placeholder="请选择" multiple v-model="getEditFieldObj.fieldValue" allow-clear allow-search>
          <jw-option v-for="item in JSON.parse(getEditFieldObj.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-option>
        </jw-select>
      </template>
      <!--数字  -->
      <template v-else-if="fieldType === 7">
        <jw-input-number v-if="JSON.parse(fieldExt)?.numberFormat === '100'" :precision="3" v-model="getEditFieldObj.fieldValue" class="jw-number-input" placeholder="请输入" ref="focusRef" @press-enter="editSave" allow-clear hide-button>
          <template #append> % </template>
        </jw-input-number>
        <jw-input-number v-else-if="JSON.parse(fieldExt)?.numberUnit" v-model="getEditFieldObj.fieldValue" placeholder="请输入" class="jw-number-input" ref="focusRef" @press-enter="editSave" allow-clear :precision="Number(JSON.parse(fieldExt)?.numberFormat)">
          <template #append> {{ JSON.parse(fieldExt)?.numberUnit || '' }} </template>
        </jw-input-number>
        <jw-input-number v-else ref="focusRef" @press-enter="editSave" v-model="getEditFieldObj.fieldValue" placeholder="请输入" class="jw-number-input" allow-clear :precision="Number(JSON.parse(fieldExt)?.numberFormat)" />
      </template>
      <!-- 日期格式 -->
      <template v-else-if="fieldType === 8">
        <jw-date-picker default-popup-visible v-model="getEditFieldObj.fieldValue" :show-time="isShowTime(fieldExt)" :value-format="isShowTime(fieldExt) ? 'YYYY-MM-DD HH:mm:00' : 'YYYY-MM-DD'" :format="fieldExt" position="br" @change="editSave" class="width100" />
      </template>

      <!-- 日期范围 -->
      <template v-else-if="fieldType === 9">
        <jw-range-picker v-if="fieldExt === '0'" default-popup-visible v-model="getEditFieldObj.fieldValue" @change="editSave" />
        <jw-range-picker v-else-if="fieldExt === '1'" default-popup-visible v-model="getEditFieldObj.fieldValue" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" @change="editSave" />
        <jw-range-picker v-else @change="editSave" default-popup-visible v-model="getEditFieldObj.fieldValue" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" />
      </template>
      <!-- 级联 -->
      <template v-else-if="fieldType === 10">
        <jw-cascader :trigger-props="{ updateAtScroll: true }" :options="setDisabledOPtion(JSON.parse(fieldExt))" placeholder="请选择" v-model="getEditFieldObj.fieldValue" path-mode allow-clear allow-search @blur="editSave" />
      </template>
      <!-- 查找关联 -->
      <template v-else-if="fieldType === 12 || fieldType === 25">
        <xl-update-fields popup-container="body" :singleFieldEdit="true" @lineEdit="lineEdit" :modules="getFieldModule()" :formatData="[getFieldModule]" @blur="editSave" />
      </template>
      <!-- 金额 -->
      <template v-else-if="fieldType === 16">
        <!-- <jw-input-number v-model="getEditFieldObj.fieldValue" ref="focusRef" @press-enter="editSave" placeholder="请输入" :precision="Number(fieldExt)" class="jw-number-input" /> -->
        <jw-input-number v-model="getEditFieldObj.fieldValue" ref="focusRef" @press-enter="editSave" placeholder="请输入" class="jw-number-input" :formatter="(event) => isShowThousandFormatter(event, getEditFieldObj)" :parser="(value) => value.replace(/,/g, '')" :precision="tools.isJSON(fieldExt) ? Number(JSON.parse(fieldExt)?.numberFormat) : fieldExt" />
      </template>
      <!-- 百分比 -->
      <template v-else-if="fieldType === 23">
        <jw-input-number ref="focusRef" v-model="getEditFieldObj.fieldValue" @press-enter="editSave" placeholder="请输入" allow-clear hide-button :formatter="(event) => isShowThousandFormatter(event, getEditFieldObj)" :parser="(value) => value.replace(/,/g, '')" :precision="Number(JSON.parse(fieldExt)?.numberFormat)">
          <template #append> % </template>
        </jw-input-number>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, nextTick, computed, inject } from 'vue';
import useEditFields from '@/hooks/edit-field';
import { Message } from '@arco-design/web-vue';
import dayjs from 'dayjs';
import { tools } from '@/utils/tools.js';
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
const { editField } = useEditFields();
// 精度
import useThousandOption from '@/hooks/thousand';
// 处理精度 千分符
const { isShowThousandFormatter } = useThousandOption();
const emits = defineEmits(['cb', 'closeModal', 'cancelEdit']);
const data = reactive({
  loading: false,
  saveNewFieldValue: '', //修改成功之后的值
  detailRefresh: inject('detailParams')?.detailRefresh,
  textList: [0, 11], //单行、超链接
  redioList: [2, 4], //下拉单选，单选
  selectList: [3, 5], //下拉多选，多选
  numberList: [7, 16, 23], //数字金额百分比
  focusList: [0, 1, 7, 11, 16, 23] //需要聚焦且失去焦点保存的字段类型
});
const props = defineProps({
  editFieldsObj: {
    //数据对象
    type: Object,
    required: true,
    default: () => {
      return {};
    }
  },
  zIndex: {
    //详情弹窗的层级
    type: String || Number,
    required: true,
    default: 1001 //默认是1001
  },
  fieldInfo: {
    //字段信息 查找关联编辑拼module结构
    type: Object,
    default: () => {
      return {};
    }
  }
});
const fieldEditMethods = inject('fieldEditMethods'); //调用父组件方法
const updateEditShow = //编辑之后把编辑状态恢复
  fieldEditMethods?.updateEditShow ||
  (() => {
    return '';
  });
const handleEsc = (event) => {
  // 检查按下的是否是 ESC 键 (键值为 27)
  if (event.key === 'Escape' || event.keyCode === 27) {
    editSave('esc');
    event.stopPropagation(); // 阻止事件冒泡
  }
};

eventListener('keydown', handleEsc, window, true);

const getFieldModule = () => {
  const _fieldModule = {
    ...props.fieldInfo,
    value: props.fieldInfo?.fieldKey,
    label: props.fieldInfo?.fieldName,
    customValue: props.editFieldsObj.fieldValue,
    type: 20,
    lineEditParams: {
      entity: getEditFieldObj.value?.isSubForm ? getEditFieldObj.value.subEntityId : getEditFieldObj.value.entity,
      businessId: getEditFieldObj.value.businessId
    },
    setting: props.fieldInfo
  };
  if (fieldType.value == 12) {
    _fieldModule['fieldValue'] = props.editFieldsObj.fieldValue?.value || '';
    _fieldModule['fieldValueName'] = props.editFieldsObj.fieldValue?.label || '';
  } else if (fieldType.value == 25) {
    _fieldModule['fieldValue'] = (props.editFieldsObj?.fieldValue?.length && props.editFieldsObj?.fieldValue?.map((v) => v?.value)) || [];
    _fieldModule['fieldValueName'] = (props.editFieldsObj?.fieldValue?.length && props.editFieldsObj?.fieldValue?.map((v) => v?.label)) || [];
  }
  return _fieldModule;
};
const oldFieldValue = JSON.parse(JSON.stringify(props.editFieldsObj));
const focusRef = ref(); //单行文本/多行文本/级联数字金额百分比 聚焦的字段类型
const fieldType = computed(() => props.editFieldsObj.fieldType); //字段类型
const fieldExt = computed(() => props.editFieldsObj.fieldExt); //字段信息
const getEditFieldObj = ref(props.editFieldsObj);
const drawerRef = document.querySelector('.arco-drawer-body');
const scrollPosition = ref(0);
//获取查找关联选择的值
const associationNewValue = ref(null);
//获取多选的值
const lineEdit = (item) => {
  if (fieldType.value == 25) {
    getEditFieldObj.value.fieldValue = item?.map((v) => v.value) || [];
    associationNewValue.value =
      item?.map((v) => {
        return {
          label: v.label,
          value: v.value,
          business: props.fieldInfo?.fieldExt,
          deleted: false
        };
      }) || [];
  } else if (fieldType.value == 12) {
    if (item?.length > 0) {
      getEditFieldObj.value.fieldValue = item?.[0]?.value;
      associationNewValue.value = {
        label: item?.[0]?.label,
        value: item?.[0]?.value,
        business: props.fieldInfo?.fieldExt,
        deleted: false
      };
    } else {
      associationNewValue.value = {};
    }
  }
};

// 是否展示时间
const isShowTime = (ext) => {
  if (ext?.includes('HH:mm') || ext?.includes('HH:mm:ss') || ext?.includes('hh:mm')) {
    return true;
  } else {
    return false;
  }
};
// 处理级联的下拉选项
const setDisabledOPtion = (options) => {
  options.forEach((option) => {
    const isEnabled = option.isEnabled;
    option['disabled'] = !isEnabled;
    if (option.children) {
      setDisabledOPtion(option.children);
    }
  });
  return options;
};
// 对字段的一些默认处理
const processing = () => {
  console.log('fieldType.value--', fieldType.value);
  nextTick(() => {
    if (data.focusList.includes(fieldType.value)) focusRef.value.focus(); //这些类型自动聚焦
  });
};
// 处理上传参数
const getFieldVal = () => {
  let setFieldValue = getEditFieldObj.value.fieldValue ?? '';
  //   console.log("setFieldValue----",setFieldValue);
  if (data.selectList.includes(fieldType.value)) {
    //多选/下拉多选特殊处理
    setFieldValue = setFieldValue && Array.isArray(setFieldValue) ? setFieldValue?.filter((i) => i != '')?.join(',') : '';
  } else if (fieldType.value == 9) {
    //日期
    const hasValue = tools.hasDateRange(setFieldValue);
    const v = { beginDate: setFieldValue?.[0], endDate: setFieldValue?.[1] };
    setFieldValue = hasValue ? JSON.stringify(v) : '';
  } else if (fieldType.value == 10) {
    //级联
    setFieldValue = setFieldValue && Array.isArray(setFieldValue) ? setFieldValue?.join('/') : '';
  } else if (fieldType.value === 16) {
    //金额
    setFieldValue = !isNaN(parseFloat(setFieldValue)) ? tools.setPrice(setFieldValue) : '';
  } else if (fieldType.value === 23) {
    //百分比
    setFieldValue = !isNaN(parseFloat(setFieldValue)) ? tools.setPercentage(setFieldValue, JSON.parse(fieldExt.value).numberFormat) : '';
  } else if (fieldType.value === 12) {
    setFieldValue = associationNewValue.value?.value || null;
  } else if (fieldType.value === 25) {
    setFieldValue = associationNewValue.value?.map((v) => v.value) || null;
  }
  return setFieldValue;
};

// 保存
const saveFields = async () => {
  const params = {
    entity: getEditFieldObj.value?.isSubForm ? getEditFieldObj.value.subEntityId : getEditFieldObj.value.entity,
    fieldKey: getEditFieldObj.value.fieldKey,
    businessId: getEditFieldObj.value.businessId,
    fieldValue: getFieldVal(),
    apiIndex: getEditFieldObj.value.entity + Math.random()
  };
  data.loading = true;
  await editField(params)
    .then((res) => {
      if (!res.error) {
        //编辑成功 临时改变当前显示的值
        data.saveNewFieldValue = getEditFieldObj.value.fieldValue;
        if (fieldType.value == 16) {
          data.saveNewFieldValue = params?.fieldValue;
        }
        // if (!props.editFieldsObj.isList) {
        //详情
        if (fieldType.value == 9 || fieldType.value == 23) {
          //日期范围、金额，百分比
          data.saveNewFieldValue = params?.fieldValue;
        }
        // }
        let cbParams = {
          fieldValue: data.saveNewFieldValue
        };
        if (fieldType.value == 12 || fieldType.value == 25) {
          cbParams = {
            fieldValue: associationNewValue.value
          };
        }
        emits('cb', cbParams);
        updateEditShow();
        if (drawerRef) {
          scrollPosition.value = drawerRef?.scrollTop;
        }
        data?.detailRefresh?.(scrollPosition.value);
        Message.success('保存成功');
      } else {
        emits('cancelEdit'); //重置为可编辑状态
        updateEditShow();
      }
      data.loading = false;
    })
    .catch((err) => {
      data.loading = false;
      emits('cancelEdit'); //重置为可编辑状态
      updateEditShow();
      console.log(err);
    });
};
// 判断编辑的值是否有效
const getEffective = () => {
  const fieldValue = getEditFieldObj.value.fieldValue ?? '';
  // console.log('旧值---', oldFieldValue.fieldValue);
  // console.log('新值---', fieldValue);
  if ((data.focusList.includes(fieldType.value) || data.redioList.includes(fieldType.value) || fieldType.value == 8) && fieldValue === oldFieldValue.fieldValue) return false; //单行、多行文本、单选、下拉单选、超链接、数字，金额、百分比，日期
  if (data.selectList.includes(fieldType.value) || fieldType.value == 9 || fieldType.value == 10) {
    //多选/下拉多选/日期范围/级联
    const getOldFieldValue = oldFieldValue.fieldValue instanceof Array ? oldFieldValue.fieldValue?.join('/') : oldFieldValue.fieldValue;
    const getNewfieldValue = fieldValue instanceof Array ? fieldValue?.filter((i) => i != '')?.join('/') : fieldValue;
    if (getOldFieldValue === getNewfieldValue) return false;
  }
  if (fieldType.value == 12 && oldFieldValue.fieldValue?.value == associationNewValue.value?.value) {
    return false;
  }
  if (fieldType.value == 25) {
    const newValueLength = associationNewValue.value?.length || 0;
    if (oldFieldValue.fieldValue?.length === newValueLength) {
      if (newValueLength === 0) {
        return false;
      }
      let number = 0;
      oldFieldValue?.fieldValue?.map((ofv) => {
        if (fieldValue.indexOf(ofv?.value) > -1) {
          number++;
        }
      });
      if (oldFieldValue?.fieldValue?.length && number == oldFieldValue?.fieldValue?.length) {
        return false;
      }
    }
  }

  return true;
};

// 点击蒙层或者失去焦点
const editSave = async (fromType) => {
  emits('closeModal'); //关闭蒙层
  if (fromType === 'esc') {
    emits('cancelEdit'); //重置为可编辑状态
    updateEditShow();
    return;
  }

  const isEffective = getEffective();
  if (!isEffective) {
    //新旧值相同不调接口

    emits('cancelEdit'); //重置为可编辑状态
    updateEditShow();
    return;
  }
  const fieldValue = getEditFieldObj.value.fieldValue ?? '';
  if (getEditFieldObj.value?.isRequired) {
    //必填校验
    if ((data.numberList.includes(fieldType.value) && isNaN(parseFloat(fieldValue))) || (!data.numberList.includes(fieldType.value) && (!fieldValue || fieldValue?.length == 0)) || (fieldType.value == 12 && !associationNewValue.value?.value) || (fieldType.value == 25 && !associationNewValue.value?.length)) {
      Message.warning('必填字段不能为空!');
      emits('cancelEdit'); // 重置为可编辑状态
      updateEditShow();
      return;
    }
  }
  if (fieldType.value == 11 && fieldValue && !tools.checkLink(fieldValue)) {
    Message.warning('格式不正确，请以http:// 或 https:// 开头，且不能包含汉字!');
    emits('cancelEdit'); // 重置为可编辑状态
    updateEditShow();
    return;
  }
  await saveFields();
};

defineExpose({ processing, editSave });
</script>
<style scoped lang="less">
@import './quick-Edit-content.less';
</style>
